import { Link } from '@inertiajs/react';
import { Search } from 'lucide-react';

interface SearchLinkProps {
    className?: string;
    showLabel?: boolean;
}

export default function SearchLink({ className = '', showLabel = true }: SearchLinkProps) {
    return (
        <Link
            href="/search"
            aria-label="Search"
            className={`lux-caps flex items-center gap-1.5 text-[9px] text-[#F5F5F5] transition-all duration-300 hover:tracking-[0.28em] ${className}`}
        >
            <Search className="h-2.5 w-2.5" strokeWidth={1.5} />
            {showLabel && <span>Search</span>}
        </Link>
    );
}
